var module = angular.module('octopusApp.projects');

module.directive('packageSelector', function(octopusRepository) {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            action: '=',
            project: '=',
            feeds: '=',
            localNames: '=',
            feedType: '=',
            onChange: '&'
        },
        templateUrl: 'areas/projects/views/package_selector.html',
        link: function(scope, element) {

            if (!scope.feedType){
                scope.feedType = 'NuGet';
            }
        
            scope.reset = {
                feed: ""
            };

            if (scope.feeds.length > 0) {
                scope.reset.feed = "feeds-builtin";
            }

            scope.feedChanged = feedChanged;

            function feedChanged() {
                if (scope.onChange) {
                    scope.onChange();
                }
            }

            scope.looksLikeVersion = false;
            scope.checkIfLooksLikeVersion = function() {
            scope.looksLikeVersion = false;
            var packageId = scope.action.Properties["Octopus.Action.Package.PackageId"];
            if (packageId) {
                if (packageId.match(/\.[0-9]+\.?$/)) {
                    scope.looksLikeVersion = true;
                }
            }
            feedChanged();
        };

            scope.getPackages = function(searchText) {
                var selectedFeedId = scope.action.Properties["Octopus.Action.Package.FeedId"];
                var selectedFeed = scope.feedsById[selectedFeedId];
                var searchOptions = {
                    packageId: searchText,
                    partialMatch: true,
                    includeMultipleVersions: false,
                    includePreRelease: true,
                    includeNotes: false
                };
                return octopusRepository.Feeds.search(selectedFeed, searchOptions);
            };

            scope.feedsById = {};
            _.each(scope.feeds, function (f) { scope.feedsById[f.Id] = f; });

            if (!scope.action.Properties["Octopus.Action.Package.FeedId"] && scope.feeds.length > 0) {
                scope.action.Properties["Octopus.Action.Package.FeedId"] = "feeds-builtin";
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/package_selector.js
// module id = 2725338189203806
// module chunks = 1